import moment from "moment";

export function CreateEndpoint(endpoint, state) {
  return process.env.VUE_APP_API_BASE_URL + endpoint;
}

export function isEnabled(resource) {
  return process.env[`VUE_APP_${resource}_ENABLED`] === "true";
}

export function Auth() {
  return new AuthJWT();
}

class AuthJWT {
  constructor(cookieName = "testing_auth_a") {
    this.cookieName = cookieName;
    this.description = "AUTH_DEV";
    this.version = "1.0.0";
  }

  getToken() {
    const cookieToken = this._getCookie(this.cookieName);
    if (cookieToken) {
      const documentToken = document.location.pathname.split("/");
      if (documentToken.length >= 3 && documentToken[2].length > 0) {
        if (cookieToken === documentToken[2]) {
          return cookieToken;
        }
        return documentToken[2];
      }

      return cookieToken;
    }

    const documentToken = document.location.pathname.split("/");
    if (documentToken.length >= 3 && documentToken[2].length > 0) {
      this.setToken(documentToken[2]);
      return documentToken[2];
    }

    const urlParams = new URLSearchParams(document.location.search);
    const queryToken = urlParams.get("token");
    if (queryToken) {
      this.setToken(queryToken);
      return queryToken;
    }

    return null;
  }

  setToken(value) {
    const expires = moment().add(30, "minutes").toDate().toUTCString();
    document.cookie = `${this.cookieName}=${value}; expires=${expires}; path=/; SameSite=Strict`;
  }

  logout() {
    this.removeToken();
  }

  removeToken() {
    document.cookie = `${this.cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  _getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) {
        return value;
      }
    }
    return null;
  }

  xhrCheck(e) {
    if (!!e.response.status && e.response.status == 401) {
      this.removeToken();
      document.location.reload();
      return false;
    }
  }

  console(messages, type) {
    if (process.env.VUE_APP_CONSOLE_LOG) {
      let c = console.log;

      if (typeof type !== "undefined") {
        c = console[type];
      }

      console.group(this.description + " " + this.version);

      //- si es un array
      if (typeof messages === "object") {
        for (let item of messages) {
          c(item);
        }
      }

      //- si es texto
      if (typeof messages === "string") {
        c(messages);
      }

      console.groupEnd();
    }
  }
}
